import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import { DeviceTimezone } from './device-timezone';

@Injectable({ providedIn: 'root' })
export class DeviceTimezoneService {
  async getCurrentOffsetMinutes() {
    if (!Capacitor.isNativePlatform()) return moment().utcOffset();

    try {
      const tz = await DeviceTimezone.getTimezone();
      return tz.currentOffsetMinutes;
    } catch (e) {
      return moment().utcOffset();
    }
  }
}
